<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-edit"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <h2 class="title-main">
                        {{ 'CESSIONARY_DATA' | translate}}
                    </h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">
            <div class="section">

                <div class="section-content">
                    <div class="row form-row">
                        <div class="col-5">
                            <app-select [ngModel]="insuredProduct.configuration.cession.type?.code"
                                        (ngModelChange)="insuredProduct.configuration.cession.type = {code: $event}"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.CESSION_PARTY_TYPE].itemList"
                                        [hasEmpty]="false"
                                        [errorStateMatcher]="matchers.type"
                                        [label]="'CESSIONARY_TYPE' | translate">
                            </app-select>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-5">
                            <app-input [(ngModel)]="insuredProduct.configuration.cession.name"
                                       [errorStateMatcher]="matchers.name"
                                       [label]="'CESSIONARY_NAME' | translate">
                            </app-input>
                        </div>

                        <ng-container
                                *ngIf="insuredProduct.configuration.cession.type.code === cessionPartyType.LEGAL_ENTITY">
                            <div class="col-2">
                                <app-numpad [(ngModel)]="insuredProduct.configuration.cession.nip"
                                            [errorStateMatcher]="matchers.nip"
                                            [config]="{maxlength: 10, allowLeadingZeros: true}"
                                            [label]="'LABEL.NIP' | translate">
                                </app-numpad>
                            </div>


                            <div class="col-2">
                                <app-numpad [(ngModel)]="insuredProduct.configuration.cession.regon"
                                            [errorStateMatcher]="matchers.regon"
                                            [config]="{maxlength: 14, allowLeadingZeros: true}"
                                            [label]="'LABEL.REGON' | translate">
                                </app-numpad>
                            </div>
                        </ng-container>
                    </div>

                    <ng-container
                            *ngIf="insuredProduct.configuration.cession.type.code === cessionPartyType.LEGAL_ENTITY">
                        <div class="row form-row">
                            <div class="col-5">
                                <app-select [ngModel]="insuredProduct.configuration.cession.countryOfOrigin?.code"
                                            (ngModelChange)="updateCountry($event)"
                                            [itemList]="(dictionaries$|async)[dictionaryTypes.NATIONALITY].itemList"
                                            [errorStateMatcher]="matchers.countryOfOrigin"
                                            [label]="'ORIGIN_COUNTRY' | translate">
                                </app-select>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <ng-container
                        *ngIf="insuredProduct.configuration.cession.type.code === cessionPartyType.LEGAL_ENTITY">

                    <div class="separator"></div>

                    <app-address-form [aside]="true"
                                      #addressFormComponent
                                      [title]="'ADDRESS' | translate"
                                      [address]="insuredProduct.configuration.cession.address"
                                      prefix="cession.address">
                    </app-address-form>
                </ng-container>
            </div>
        </div>
    </div>


    <div class="aside-footer">
        <div class="footer-btn">
            <button (click)="close()"
                    class="btn btn-secondary"
                    type="button">
                {{ 'BUTTON.CANCEL' | translate }}
            </button>

            <button (click)="save()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.SAVE' | translate }}
            </button>
        </div>
    </div>
</div>
